import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../../../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../../common/utility';
import { BaseService } from '../../../../shared/services/base.service';
import { FormLabelComponent } from '../../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../../components/form/message/message.component';
import { AppConstants } from '../../../../shared/constants/constants';
import { AppMessages } from '../../../../shared/constants/messages';

import { InvoiceListModel } from '../../../../models/payment/invoice.model';
import { DialogService } from '../../../../shared/services/dialog.service';
import { AccountPaymentService } from '../account-payment.service';

@Component({
    selector: 'add-order-popup',
    templateUrl: 'add-order-popup.component.html',
    providers: [AccountPaymentService]
})

export class AddOrderPopupComponent implements OnInit {
    addOrderPopupForm: FormGroup;
    public isSuccess: boolean;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        public dialogRef: MdDialogRef<AddOrderPopupComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA)  public data: any,
        public accountPaymentService: AccountPaymentService) { }

    ngOnInit() {
        this.isSuccess = false;
        this.createForm();
    }

    createForm() {
        this.addOrderPopupForm = this.formBuilder.group({
            orderNumber: ['', [Validators.required]]
        });
    }

    onCloseDialog() {
        this.dialogRef.close(this.isSuccess);
    }

    onSubmit() {
      if (this.addOrderPopupForm.dirty && this.addOrderPopupForm.valid) {
          let invoiceSelected = new Array();
          this.data.invoiceSelected.forEach(element => {
              invoiceSelected.push(element['id']);
          });
          const param = {
              invoiceId: invoiceSelected,
              OrderNumber: this.addOrderPopupForm.value.orderNumber
          };
          this.accountPaymentService.addOrderNumber(param).subscribe(
              result => {
                  if (result) {
                      this.dialogService.openSuccessDialog({
                          message: Utility.stringFormat(AppMessages.payment.addSuccess, ['Order Number'])
                      });
                      this.isSuccess = true;
                      this.onCloseDialog();
                  }
              }
          );
      }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/list-invoice/add-order-popup.component.ts